import { Platform, Dimensions } from 'react-native';

const { height } = Dimensions.get('window');

const iosRatio = height <= 677 ? 0.69 : 0.593;
const defaultNormalTrayHeight = Platform.OS === 'android' ? 470 : height * iosRatio;

export { defaultNormalTrayHeight };
